// src/lib/toast.js
import { createStandaloneToast } from '@chakra-ui/react';

const { toast } = createStandaloneToast();

const defaultConfig = {
  duration: 5000,
  isClosable: true,
  position: 'bottom-middle',
};

export const toastService = {
  success: (message) => {
    toast({
      title: message,
      status: 'success',
      ...defaultConfig,
    });
  },

  error: (message) => {
    toast({
      title: message,
      status: 'error',
      ...defaultConfig,
    });
  },
};

// We can still export the raw toast if needed for special cases
export { toast };
